// src/layouts/AuthLayout.js
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import "../custom.css";
import config from "../config/config";
import { applyThemeCss, removeThemeCss } from '../utils/themeCss';
import { getCompanyPrefixedRedirect } from "../utils/landingCompany";
/*
import { useContext } from "react";
import config from "../config/config";
import avatar from "../images/turning-point-w-powered-by-white.png"; // import image
import Logo from "../components/logo/Logo";
*/
import { ThemeContext } from "../context/ThemeContext";

export default function AuthLayout() {
  const theme = useContext(ThemeContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTo = getCompanyPrefixedRedirect(
      location.pathname,
      location.search,
    );
    if (redirectTo && redirectTo !== `${location.pathname}${location.search}`) {
      navigate(redirectTo, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    let mounted = true;
    const id = 'auth-theme';

    const load = async () => {
      try {
        const cssPath = theme?.css_file_path;
        if (mounted && cssPath) {
          const href = cssPath.startsWith('http') || cssPath.startsWith('blob:')
            ? cssPath
            : `${config.assetsBaseUrl.replace(/\/$/, '')}/uploads/${String(cssPath).replace(/^\/+/, '')}`;
          applyThemeCss({ id, href, cacheBust: theme?.updated_at || Date.now() });
        }
      } catch (e) {
        // ignore
      }
    };

    load();
    return () => {
      mounted = false;
      removeThemeCss({ id });
    };
  }, [theme]);

  return (
    <div className="application-fe">
      <style>{`
      body{
        font-family:var(--font-family-primary);
        font-size:var(--font-size14);
        font-weight:var(--font-wght400);
        color:var(--color-heading);
        background-color: transparent;
      }
      `}</style>
      <Outlet />
    </div>
  );
}
